import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestService } from '../../services/rest/rest.service';
@Injectable()
export class BrightcovePlayerRestService {
  constructor(private restService: RestService) {
  }

  triggerSessionAlive(): Observable<void> {
    return this.restService.getResource('session.keepalive').get();
  }
}
